<template>
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :search.sync="searchForm"
               :page="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="onLoad"
               @on-load="onLoad">

    </avue-crud>
  </basic-container>
</template>

<script>
import { getPage, add, update, remove, getDetail } from "@/api/v4ward/digitaltickets/feetaxtype/FeeTaxType.js";
import {mapGetters} from "vuex";

export default {
  data() {
    return {
      deptNameFlag:false,
      projectList:[],
      deptList:[],
      form: {
      },
      query: {
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      option: {
        labelWidth: 120,
        // indexLabel:"序号",
        menu: true,
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        addBtn: true,
        delBtn: true,
        // searchBtn: false,
        // emptyBtn: false,
        searchMenuSpan: 12,
        border: true,
        // index: true,
        viewBtn: false,
        dialogClickModal: false,
        column: [
          {
            label: "税收分类编码",
            prop: "taxCode",
            search: true,
            searchSpan: 6,
            maxlength: 50,
            showWordLimit:true,
            searchLabelWidth: 100,
            rules: [{
              required: true,
              message: "请输入税收分类编码",
              trigger: "blur"
            }]
          },
          {
            label: "税收分类名称",
            prop: "taxFullName",
            search:true,
            searchLabelWidth: 100,
            maxlength: 50,
            showWordLimit:true,
            searchSpan: 6,
            rules: [{
              required: true,
              message: "请输入税收分类名称",
              trigger: "blur"
            }]
          },
          {
            label: "税收分类简称",
            prop: "taxName",
            maxlength: 50,
            showWordLimit:true,
            type: 'input',
            search: false,
            rules: [{
              required: true,
              message: "请输入税收分类简称",
              trigger: "blur"
            }]
          },
          {
            label: "发票行业代码",
            prop: "industryCode",
            maxlength: 20,
            type: 'input',
            rules: [{
              required: true,
              message: "请输入发票行业代码",
              trigger: "blur"
            }]
          },
          {
            label: "创建人",
            prop: "createUserName",
            addDisplay:false,
            editDisplay:false,
          },
          {
            label: "创建时间",
            prop: "createTime",
            addDisplay:false,
            editDisplay:false,
          },
        ]
      },
      data: [],
      firstProjectId: false,
      oldProjectId: '',
      disabled: false,
      searchForm:{

      },
    };
  },
  watch: {
  },
  mounted(){
    this.adjustView();
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  created(){
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.feetaxtype_add, false),
        delBtn: this.vaildData(this.permission.feetaxtype_delete, false),
        editBtn: this.vaildData(this.permission.feetaxtype_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(",");
    }
  },
  methods: {
    adjustView() {
      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    rowSave(row, done, loading) {
      console.log("form>>>>>>>",this.form);
      add(row).then(() => {
        this.onLoad();
        this.$message.success('操作成功!');
        done();
      }, error => {
        window.console.log(error);
        loading();
      });
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(() => {
        this.onLoad();
        this.$message.success('操作成功!');
        done();
      }, error => {
        window.console.log(error);
        loading();
      });
    },
    rowDel(row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return remove({ids: row.id});
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return remove({ids: this.ids});
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    async beforeOpen(done, type) {
      if (["edit"].includes(type)) {
        getDetail({id:this.form.id}).then(({data}) => {
          this.form = data;
        });
      }

      if (["add"].includes(type)) {
        this.form = {
          taxCode : '',
          taxFullName : '',
          taxName : '',
          id : ''
        };
      }
      done();
    },
    searchReset() {
      setTimeout(()=>{
        this.query.taxCode = '';
        this.query.taxFullName = '';
        this.onLoad();
      },0)
    },
    searchChange(params, done) {
      this.query.taxCode = params.taxCode
      this.query.taxFullName = params.taxFullName
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getPage(
        Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
      ).then(({data}) => {
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
      });
    }
  }
};
</script>

<!--最大化-->
<style lang="scss" scoped>
::v-deep .el-form-item {
  width: 100%;
}
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}
</style>
